import validate from "/app/node_modules/nuxt/dist/pages/runtime/validate.js";
import manifest_45route_45rule from "/app/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  manifest_45route_45rule
]
export const namedMiddleware = {
  auth: () => import("/app/src/middleware/auth.ts"),
  guest: () => import("/app/src/middleware/guest.ts"),
  "not-for-mds": () => import("/app/src/middleware/not-for-mds.ts"),
  "redirect-login": () => import("/app/src/middleware/redirect-login.ts")
}